export default __webpack_public_path__ + "static/viinitie-banner-wedding-desktop-narrow.458ee32d82f99218c53b16792fdf10be.webp";